export const routes = [
    {
        name: "Land Prices (Suburbs)",
        route_name: "land-prices-suburbs",
        description: "Land Prices of various Suburbs across Nairobi"
    },
    {
        name: "Land Prices (Satellite Towns)",
        route_name: "land-prices-satellites",
        description: "Land Prices of various Satellites Towns in Nairobi"
    },
    {
        name: "Land Transactions",
        route_name: "land-transactions",
        description: "Land Transactions in Nairobi"
    },
    {
        name: "Hospitality",
        route_name: "hospitality-intelligence",
        description: "Hospitality Data & Analytics"
    },
    {
        name: "Construction",
        route_name: "construction",
        description: "Construction Data & Analytics"
    },
]